'use strict';
angular.module('pmtPlacesApp.controllers').controller('TasksCtrl', [
	'$q',
	'$stateParams',
	'$scope',
	'auth',
	'pmtFeatureFlagService',
	'pmtElmService',
	'$timeout',
	function ($q, $stateParams, $scope, auth, pmtFeatureFlagService, pmtElmService, $timeout) {
		$scope.enabled = false;

		/**
		 * @typedef {typeof import('../../../../../constants/networks.mts').networks[keyof typeof import('../../../../../constants/networks.mts').networks]} Network
		 */

		/**
		 * @param {Record<string, any>} site
		 * @param {Network} network
		 */
		const hasCategory = (site, network) => {
			const categoryChecks = {
				here: () => !!site.places?.here?.categories?.primaryCategory?.id,
				overture: () => !!site.places?.overture?.categories?.primaryCategory?.id,
				factual: () => !!site.places?.factual?.categories?.length > 0,
				tomtom: () => !!site.places?.tomtom?.category
			};

			return categoryChecks[network]?.() ?? false;
		};

		$q.all([
			auth.getUser($stateParams.site),
			pmtFeatureFlagService.getFeatures($stateParams.site)
		]).then(([user]) => {
			$scope.analytics = user.selectedSite.analytics;
			$scope.isAdmin = user.isAdmin;
			$scope.site = $stateParams.site;

			const localAccess = { ...user.localAccess };
			localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
			localAccess.permissions = localAccess.permissions
				? [...localAccess.permissions.values()]
				: [];
			const user_ = { ...user, localAccess: localAccess };

			$scope.facebookArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/facebook',
				siteName: $stateParams.site,
				user: user_
			};

			$scope.appleArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/apple',
				siteName: $stateParams.site,
				user: user_
			};

			$scope.googleArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/google',
				siteName: $stateParams.site,
				user: user_
			};

			$scope.bingArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/bing',
				siteName: $stateParams.site,
				user: user_
			};

			$scope.ptvArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/ptv',
				siteName: $stateParams.site,
				user: user_
			};

			$scope.hereArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/here',
				siteName: $stateParams.site,
				user: user_,
				hasCategory: hasCategory(user.selectedSite, 'here')
			};

			$scope.tomtomArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/tomtom',
				siteName: $stateParams.site,
				user: user_,
				hasCategory: hasCategory(user.selectedSite, 'tomtom')
			};

			$scope.foursquareArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/foursquare',
				siteName: $stateParams.site,
				user: user_,
				hasCategory: hasCategory(user.selectedSite, 'factual')
			};

			$scope.overtureArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/overture',
				siteName: $stateParams.site,
				user: user_,
				hasCategory: hasCategory(user.selectedSite, 'overture')
			};

			$scope.trustpilotTaskArgs = {
				claimUrl: '/listings/' + $stateParams.site + '/claim/trustpilot',
				uploadChangesUrl: '/listings/' + $stateParams.site + '/conflicts/trustpilot/upload',
				siteName: $stateParams.site,
				user: user_
			};

			$timeout(function () {
				pmtElmService.sendData('Tasks.Trustpilot.Main', 'reload_Tasks_Trustpilot_Main', null);
			}, 10);
		});
	}
]);
